import { useState, useEffect } from "react";
import userManagementApi, { ISalesRep } from "~/apis/userManagement";
import jobApi, { ITradeType } from "~/apis/job";
import { UseJobDataReturn } from "../types/add-job.types";

export const useJobData = (isOpen: boolean): UseJobDataReturn => {
  const [salesReps, setSalesReps] = useState<ISalesRep[]>([]);
  const [tradeTypes, setTradeTypes] = useState<ITradeType[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  // Fetch Sales Reps and Trade Types from API
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        // Fetch Sales Reps
        const salesRepsResponse = await userManagementApi.getSalesReps();
        if (salesRepsResponse.data?.data?.responses) {
          setSalesReps(salesRepsResponse.data.data.responses);
        }

        // Fetch Trade Types
        const tradeTypesResponse = await jobApi.getTradeTypes();
        if (tradeTypesResponse.data?.data?.responses) {
          setTradeTypes(tradeTypesResponse.data.data.responses);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    if (isOpen) {
      fetchData();
    }
  }, [isOpen]);

  return {
    salesReps,
    tradeTypes,
    isLoading,
  };
};



